<template>
  <b-modal
    ref="add-cate-modal"
    hide-footer
    title="Thêm mới danh mục"
  >
    <CategoryForm
      :initial-data="formData"
      :list-cate="listCate"
      @submit="handleSubmit"
      @cancel="hideModal"
    />
  </b-modal>
</template>

<script>
import CategoryForm from './CategoryForm.vue';

export default {
  name: 'AddCategoryModal',
  components: {
    CategoryForm,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    listCate: {
      type: Array,
      required: true,
    },
  },
  methods: {
    showModal() {
      this.$refs['add-cate-modal'].show();
    },
    hideModal() {
      this.$refs['add-cate-modal'].hide();
    },
    handleSubmit(formData) {
      this.$emit('submit', formData);
    },
  },
};
</script> 
